import { render, staticRenderFns } from "./MdmLayer.vue?vue&type=template&id=6d277870&name=mdm-layer&"
import script from "./MdmLayer.vue?vue&type=script&lang=js&"
export * from "./MdmLayer.vue?vue&type=script&lang=js&"
import style0 from "./MdmLayer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports